import React, { useState } from 'react';
import {
  DollarSign,
  ShoppingCart,
  Package,
  TrendingUp,
  Eye,
  Banknote,
  XCircle,
  Truck,
  TrendingDown,
  Calculator,
  Settings
} from 'lucide-react';

const DashboardVendas = ({ dadosDashboard, isLoading, selectedDate, onDateChange }) => {
  const [isModalDailySalesOpen, setIsModalDailySalesOpen] = useState(false);

  const getDailySales = () => {
    console.log('Buscando vendas diárias...');
  };

  const handleShow = () => {
    console.log('Abrindo modal de vendas Parts...');
  };

  // ===== Helpers =====
  // pega o primeiro valor numérico (ou que possa virar número) dentre as chaves sugeridas
  const pickValue = (obj, keys = []) => {
    if (!obj || typeof obj !== 'object') return 0;
    for (const k of keys) {
      if (obj[k] != null && obj[k] !== '') {
        const n = Number(obj[k]);
        if (!Number.isNaN(n)) return n;
      }
      // tenta lower/upper
      const kl = k.toLowerCase?.();
      if (kl && obj[kl] != null && obj[kl] !== '') {
        const n = Number(obj[kl]);
        if (!Number.isNaN(n)) return n;
      }
      const ku = k.toUpperCase?.();
      if (ku && obj[ku] != null && obj[ku] !== '') {
        const n = Number(obj[ku]);
        if (!Number.isNaN(n)) return n;
      }
    }
    // fallback: primeira propriedade numérica do objeto
    for (const v of Object.values(obj)) {
      const n = Number(v);
      if (!Number.isNaN(n)) return n;
    }
    return 0;
  };

  // monta {hoje, ontem} a partir do formato "pares" OU do formato "campos + Ontem"
  const pairFromEither = (cmpPair, todayObj, yesterdayObj, todayKeys, yesterdayKeys) => {
    // formato "comparacao": {hoje, ontem}
    if (cmpPair && (cmpPair.hoje != null || cmpPair.ontem != null)) {
      return { hoje: Number(cmpPair.hoje ?? 0), ontem: Number(cmpPair.ontem ?? 0) };
    }
    // formato "novo": objHoje + objOntem com chaves diferentes
    const hoje  = pickValue(todayObj, todayKeys);
    const ontem = pickValue(yesterdayObj, yesterdayKeys);
    return { hoje, ontem };
  };

  const pctTrend = (curr, prev) => {
    if (!prev && !curr) return 0;
    if (!prev && curr) return 100;
    return ((curr - prev) / prev) * 100;
  };

  const fmtBRL = (v) =>
    (isFinite(v) ? v : 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  const fmtInt = (v) => (isFinite(v) ? Math.round(v) : 0);

  // ===== Dados vindos do backend =====
  const cmp = dadosDashboard?.comparacao || {}; // se existir, usa
  // objetos "hoje"
  const hoje_totalVendasDia          = dadosDashboard?.totalVendasDia;
  const hoje_quantidadePedidos       = dadosDashboard?.quantidadePedidos;
  const hoje_totalVendasFulfillment  = dadosDashboard?.totalVendasFulfillment;
  const hoje_totalVendasFull         = dadosDashboard?.totalVendasFull;
  const hoje_totalPedidosCancelados  = dadosDashboard?.totalPedidosCancelados;
  const hoje_totalFrete              = dadosDashboard?.totalFrete;
  const hoje_totalParts              = dadosDashboard?.totalParts;

  // objetos "ontem"
  const ont_totalVendasDia          = dadosDashboard?.totalVendasDiaOntem;
  const ont_quantidadePedidos       = dadosDashboard?.quantidadePedidosOntem;
  const ont_totalVendasFulfillment  = dadosDashboard?.totalVendasFulfillmentOntem;
  const ont_totalVendasFull         = dadosDashboard?.totalVendasFullOntem;
  const ont_totalPedidosCancelados  = dadosDashboard?.totalPedidosCanceladosOntem;
  const ont_totalFrete              = dadosDashboard?.totalFreteOntem;
  const ont_totalParts              = dadosDashboard?.totalPartsOntem;

  // monta pares (funciona para os 2 formatos)
  const vendasDia = pairFromEither(
    cmp.totalVendasDia,
    hoje_totalVendasDia, ont_totalVendasDia,
    ['TotalVendasDia'], ['TotalVendasDiaOntem']
  );

  const qtdPedidos = pairFromEither(
    cmp.quantidadePedidos,
    hoje_quantidadePedidos, ont_quantidadePedidos,
    ['QuantidadePedidos'], ['QuantidadePedidosOntem']
  );

  const vendasFulfillment = pairFromEither(
    cmp.totalVendasFulfillment,
    hoje_totalVendasFulfillment, ont_totalVendasFulfillment,
    ['TotalVendasFulfillment'], ['TotalVendasFulfillmentOntem']
  );

  const qtdVendasFull = pairFromEither(
    cmp.totalVendasFull,
    hoje_totalVendasFull, ont_totalVendasFull,
    ['TotalVendasFull'], ['TotalVendasFullOntem']
  );

  const cancelados = pairFromEither(
    cmp.totalPedidosCancelados,
    hoje_totalPedidosCancelados, ont_totalPedidosCancelados,
    ['TotalPedidosCancelados'], ['TotalPedidosCanceladosOntem']
  );

  const frete = pairFromEither(
    cmp.totalFrete,
    hoje_totalFrete, ont_totalFrete,
    ['TotalFrete'], ['TotalFreteOntem']
  );

  const parts = pairFromEither(
    cmp.totalParts,
    hoje_totalParts, ont_totalParts,
    ['totalGear'], ['totalGearOntem']
  );

  const totalBrutoHoje  = vendasDia.hoje + vendasFulfillment.hoje;
  const totalBrutoOntem = vendasDia.ontem + vendasFulfillment.ontem;

  const totalLiquidoHoje  = totalBrutoHoje - frete.hoje;
  const totalLiquidoOntem = totalBrutoOntem - frete.ontem;

  const trendVD   = pctTrend(vendasDia.hoje, vendasDia.ontem);
  const trendQP   = pctTrend(qtdPedidos.hoje, qtdPedidos.ontem);
  const trendVF   = pctTrend(vendasFulfillment.hoje, vendasFulfillment.ontem);
  const trendQF   = pctTrend(qtdVendasFull.hoje, qtdVendasFull.ontem);
  const trendCAN  = pctTrend(cancelados.hoje, cancelados.ontem);
  const trendFRE  = pctTrend(frete.hoje, frete.ontem);
  const trendTB   = pctTrend(totalBrutoHoje, totalBrutoOntem);
  const trendTL   = pctTrend(totalLiquidoHoje, totalLiquidoOntem);
  const trendParts= pctTrend(parts.hoje, parts.ontem);

  const cardStyle = {
    background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
    borderRadius: '16px',
    border: '1px solid #e2e8f0',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    transition: 'all 0.3s ease',
    cursor: 'default',
    position: 'relative',
    overflow: 'hidden'
  };

  const cardHoverStyle = {
    transform: 'translateY(-4px)',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
  };

  const iconGradients = {
    emerald: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    blue: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
    purple: 'linear-gradient(135deg, #a855f7 0%, #9333ea 100%)',
    orange: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)',
    red: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
    cyan: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
    green: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
    violet: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
    amber: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)'
  };

  const trendLabel = (pct) => {
    const s = (isFinite(pct) ? pct : 0).toFixed(1);
    return `${pct >= 0 ? '+' : ''}${s}%`;
  };

  const cards = [
    {
      id: 'daily-sales',
      title: 'Total de Vendas do Dia',
      value: fmtBRL(vendasDia.hoje),
      icon: DollarSign,
      gradient: iconGradients.emerald,
      trend: trendLabel(trendVD),
      trendUp: trendVD >= 0,
      clickable: true,
      onClick: () => {
        setIsModalDailySalesOpen(true);
        getDailySales();
      }
    },
    {
      id: 'orders-count',
      title: 'Quantidade de Pedidos',
      value: fmtInt(qtdPedidos.hoje),
      icon: ShoppingCart,
      gradient: iconGradients.blue,
      trend: trendLabel(trendQP),
      trendUp: trendQP >= 0,
      clickable: false
    },
    {
      id: 'fulfillment-sales',
      title: 'Total de Vendas Fulfillment',
      value: fmtBRL(vendasFulfillment.hoje),
      icon: Package,
      gradient: iconGradients.purple,
      trend: trendLabel(trendVF),
      trendUp: trendVF >= 0,
      clickable: false
    },
    {
      id: 'full-sales',
      title: 'Quantidade vendas full(ML)',
      value: fmtInt(qtdVendasFull.hoje),
      icon: Banknote,
      gradient: iconGradients.orange,
      trend: trendLabel(trendQF),
      trendUp: trendQF >= 0,
      clickable: false
    },
    {
      id: 'canceled-orders',
      title: 'Total de Pedidos Cancelados',
      value: fmtInt(cancelados.hoje),
      icon: XCircle,
      gradient: iconGradients.red,
      trend: trendLabel(trendCAN),
      trendUp: trendCAN >= 0, // invertido visualmente abaixo
      clickable: false,
      forceNegativeColor: true
    },
    {
      id: 'shipping',
      title: 'Frete',
      value: fmtBRL(frete.hoje),
      icon: Truck,
      gradient: iconGradients.cyan,
      trend: trendLabel(trendFRE),
      trendUp: trendFRE >= 0,
      clickable: false
    },
    {
      id: 'gross-total',
      title: 'Total Bruto',
      value: fmtBRL(totalBrutoHoje),
      icon: TrendingUp,
      gradient: iconGradients.green,
      trend: trendLabel(trendTB),
      trendUp: trendTB >= 0,
      clickable: false
    },
    {
      id: 'net-total',
      title: 'Total Liq. (Total - Frete)',
      value: fmtBRL(totalLiquidoHoje),
      icon: Calculator,
      gradient: iconGradients.violet,
      trend: trendLabel(trendTL),
      trendUp: trendTL >= 0,
      clickable: false
    },
    {
      id: 'parts-sales',
      title: 'Total em vendas de Parts',
      value: fmtBRL(parts.hoje),
      icon: Settings,
      gradient: iconGradients.amber,
      trend: trendLabel(trendParts),
      trendUp: trendParts >= 0,
      clickable: true,
      onClick: handleShow
    }
  ];

  const CardComponent = ({ card }) => {
    const [isHovered, setIsHovered] = useState(false);
    const IconComponent = card.icon;

    // card de cancelados: verde quando cai, vermelho quando sobe
    const isCancelCard = card.id === 'canceled-orders';
    const trendIsUpGood = isCancelCard ? !card.trendUp : card.trendUp;
    const trendColor = trendIsUpGood ? '#10b981' : '#ef4444';
    const trendText  = trendIsUpGood ? '#059669' : '#dc2626';
    const EffectiveTrendIcon = trendIsUpGood ? TrendingUp : TrendingDown;

    return (
      <div
        style={{
          ...cardStyle,
          cursor: card.clickable ? 'pointer' : 'default',
          ...(isHovered ? cardHoverStyle : {})
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={card.onClick}
      >
        {/* Shine effect */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: '-100%',
            width: '100%',
            height: '100%',
            background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
            transform: isHovered ? 'translateX(200%)' : 'translateX(-100%)',
            transition: 'transform 0.6s'
          }}
        />

        <div style={{ padding: '24px', position: 'relative' }}>
          {/* Header */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
            <div
              style={{
                width: '48px',
                height: '48px',
                borderRadius: '12px',
                background: card.gradient,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 14px 0 rgba(0, 0, 0, 0.15)',
                transform: isHovered ? 'scale(1.1)' : 'scale(1)',
                transition: 'transform 0.3s ease'
              }}
            >
              <IconComponent size={24} color="white" />
            </div>

            {card.clickable && isHovered && (
              <Eye size={20} style={{ color: '#9ca3af', opacity: 0.7 }} />
            )}
          </div>

          {/* Title */}
          <h3 style={{
            color: '#374151',
            fontSize: '14px',
            fontWeight: '500',
            marginBottom: '8px',
            lineHeight: '1.4'
          }}>
            {card.title}
          </h3>

          {/* Value */}
          <p style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#1f2937',
            marginBottom: '12px',
            lineHeight: '1.2'
          }}>
            {card.value}
          </p>

          {/* Trend */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <EffectiveTrendIcon size={16} style={{ color: trendColor }} />
            <span style={{ fontSize: '14px', fontWeight: '500', color: trendText }}>
              {card.trend}
            </span>
            <span style={{ fontSize: '12px', color: '#6b7280' }}>vs. ontem</span>
          </div>

          {/* Subinfo hoje/ontem (opcional) */}
          <div style={{ marginTop: 8, fontSize: 12, color: '#6b7280' }}>
            <span style={{ marginRight: 12 }}>Hoje</span>
            <span style={{ marginRight: 4, color: '#111827', fontWeight: 600 }}>
              {card.id === 'orders-count' || card.id === 'full-sales' || card.id === 'canceled-orders'
                ? fmtInt(
                    card.id === 'orders-count' ? qtdPedidos.hoje :
                    card.id === 'full-sales' ? qtdVendasFull.hoje :
                    cancelados.hoje
                  )
                : (
                    card.id === 'daily-sales' ? fmtBRL(vendasDia.hoje) :
                    card.id === 'fulfillment-sales' ? fmtBRL(vendasFulfillment.hoje) :
                    card.id === 'shipping' ? fmtBRL(frete.hoje) :
                    card.id === 'gross-total' ? fmtBRL(totalBrutoHoje) :
                    card.id === 'net-total' ? fmtBRL(totalLiquidoHoje) :
                    card.id === 'parts-sales' ? fmtBRL(parts.hoje) :
                    ''
                  )
              }
            </span>
            <span style={{ margin: '0 12px' }}>Ontem</span>
            <span style={{ color: '#111827', fontWeight: 600 }}>
              {card.id === 'orders-count' || card.id === 'full-sales' || card.id === 'canceled-orders'
                ? fmtInt(
                    card.id === 'orders-count' ? qtdPedidos.ontem :
                    card.id === 'full-sales' ? qtdVendasFull.ontem :
                    cancelados.ontem
                  )
                : (
                    card.id === 'daily-sales' ? fmtBRL(vendasDia.ontem) :
                    card.id === 'fulfillment-sales' ? fmtBRL(vendasFulfillment.ontem) :
                    card.id === 'shipping' ? fmtBRL(frete.ontem) :
                    card.id === 'gross-total' ? fmtBRL(totalBrutoOntem) :
                    card.id === 'net-total' ? fmtBRL(totalLiquidoOntem) :
                    card.id === 'parts-sales' ? fmtBRL(parts.ontem) :
                    ''
                  )
              }
            </span>
          </div>
        </div>

        {/* Decorative */}
        <div style={{
          position: 'absolute',
          bottom: '-8px',
          right: '-8px',
          width: '80px',
          height: '80px',
          borderRadius: '50%',
          background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 100%)'
        }} />
      </div>
    );
  };

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '48px',
        background: '#f8fafc'
      }}>
        <div style={{
          width: '32px',
          height: '32px',
          border: '3px solid #e5e7eb',
          borderTop: '3px solid #3b82f6',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }} />
        <span style={{ marginLeft: '12px', color: '#6b7280' }}>Carregando...</span>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }

  return (
    <div style={{ padding: '24px', backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      {/* Header */}
      <div style={{ marginBottom: '32px' }}>
        <h1 style={{ fontSize: '32px', fontWeight: 'bold', color: '#1f2937', marginBottom: '8px' }}>
          Dashboard de Vendas
        </h1>
        <p style={{ color: '#6b7280' }}>
          Acompanhe o desempenho das suas vendas em tempo real
        </p>
      </div>

      {/* Date Selector */}
      <div style={{ marginBottom: '32px' }}>
        <div style={{ ...cardStyle, padding: '24px' }}>
          <label style={{
            display: 'block',
            fontSize: '14px',
            fontWeight: '500',
            color: '#374151',
            marginBottom: '8px'
          }}>
            Selecionar Data
          </label>
          <input
            type="date"
            value={selectedDate ? selectedDate.getFullYear() + '-' +
              String(selectedDate.getMonth() + 1).padStart(2, '0') + '-' +
              String(selectedDate.getDate()).padStart(2, '0') : ''}
            onChange={(e) => {
              if (onDateChange && e.target.value) {
                const [year, month, day] = e.target.value.split('-');
                const newDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
                onDateChange(newDate);
              }
            }}
            style={{
              padding: '8px 12px',
              border: '1px solid #d1d5db',
              borderRadius: '8px',
              fontSize: '14px',
              outline: 'none',
              transition: 'border-color 0.2s'
            }}
            onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
            onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
          />
        </div>
      </div>

      {/* Cards Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
        gap: '24px'
      }}>
        {cards.map((card) => (
          <CardComponent key={card.id} card={card} />
        ))}
      </div>

      {/* Modal */}
      {isModalDailySalesOpen && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '16px',
          zIndex: 50
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '16px',
            padding: '24px',
            maxWidth: '420px',
            width: '100%'
          }}>
            <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '16px' }}>
              Detalhes das Vendas Diárias
            </h3>
            <div style={{ color: '#374151', marginBottom: 12 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Hoje</span><strong>{fmtBRL(vendasDia.hoje)}</strong>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Ontem</span><strong>{fmtBRL(vendasDia.ontem)}</strong>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 8 }}>
                <span>Variação</span>
                <strong style={{ color: trendVD >= 0 ? '#059669' : '#dc2626' }}>
                  {trendLabel(trendVD)}
                </strong>
              </div>
            </div>
            <button
              onClick={() => setIsModalDailySalesOpen(false)}
              style={{
                padding: '8px 16px',
                backgroundColor: '#3b82f6',
                color: 'white',
                borderRadius: '8px',
                border: 'none',
                cursor: 'pointer',
                transition: 'background-color 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
            >
              Fechar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardVendas;
